<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ customer.phone }} {{ customer.firstname }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CustomerTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <div v-if="(loading.customer || loading.orders)" class="table__preloader">
                        <CSpinner color="primary"/>
                    </div>
                    <div v-show="!(loading.customer || loading.orders)">
                        <CRow
                            v-if="customer.deleted"
                            form
                            class="form-group">
                            <CCol sm="12" class="col-form-label">
                                <CBadge
                                    class="w-100 py-2 px-5 size-16 removed-user"
                                    color="danger"
                                >&nbsp;Удаленный пользователь!!!&nbsp;</CBadge>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="6">
                                <div class="px-4 py-2 mb-4 border border-gray-300 rounded-md">
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>ID пользователя</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.id }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Имя и фамилия</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.firstname }} {{ customer.lastname }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Дата рождения</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.birthday ? formatDate(customer.birthday) : '-' }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Пол</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ genders[customer.gender] }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Телефон</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.phone }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Email</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.email ? customer.email : '-' }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Предпочтительный способ связи</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ communicationMethods[customer.preferred_communication_method] || '-' }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Активен</b></CCol>
                                        <CCol sm="6" class="col-form-label">
                                            <CBadge
                                                :color="getBadge(customer.enabled)"
                                            >&nbsp;{{ customer.enabled ? 'Да' : 'Нет' }}&nbsp;</CBadge>
                                        </CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Подтвержден 18+</b></CCol>
                                        <CCol sm="6" class="col-form-label">
                                            <CBadge :color="getBadge(customer.adult)">&nbsp;{{ customer.adult ? 'Да' : 'Нет' }}&nbsp;</CBadge>
                                        </CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Дата регистрации</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ formatDate(customer.created_at) }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Источник регистрации</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.registration_source ? customer.registration_source : '-' }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Предпочтительный язык</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.language ? customer.language : '-' }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Реферальный код</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.code }}</CCol>
                                    </CRow>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div v-if="customer.orders" class="px-4 py-2 mb-4 border border-gray-300 rounded-md">
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Статус клиента</b></CCol>
                                        <CCol sm="6" class="col-form-label">
                                            <CBadge :color="getCustomerStatusBadge(customer.status)">
                                                {{ getCustomerStatusText(customer.status) }}
                                            </CBadge>
                                        </CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Частота заказов</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ getOrdersFrequencyText(customer.orders_frequency) || '-' }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Количество заказов</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.orders.count }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Заказы</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.orders_count }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Заказы рестораны</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.orders_rd_count }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Заказы магазины</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.orders_gd_count }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Заказы сервисы</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.orders_ed_count }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Последний заказ</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ formatDate(customer.last_order_date) }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Сделал покупок на</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ +customer.orders.totalAmount }} руб</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Средний чек</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ +customer.average_receipt }} руб</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Способы оплаты</b></CCol>
                                        <CCol sm="6" class="col-form-label">
                                            {{ customer.payments.join(', ') }}
                                        </CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="12" class="col-form-label"><b>Адреса доставки</b></CCol>
                                        <CCol sm="12" class="col-form-label">
                                            <div v-for="address in customer.addresses" :key="address.id">
                                                <div v-if="address.tower">
                                                    {{ address.tower.name }}{{address.entrance ? `, под/корп ${address.entrance}` : ''}}{{address.floor ? `, этаж ${address.floor}` : ''}}{{address.appartment ? `, кв/офис ${address.appartment}` : ''}}
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="px-4 py-2 border border-gray-300 rounded-md">
                                    <CRow form>
                                        <CCol sm="12" class="col-form-label"><b>Статус локации (башня)</b></CCol>
                                        <CCol sm="6" class="col-form-label">
                                            Живет в Москва-Сити
                                        </CCol>
                                        <CCol sm="6" class="col-form-label">
                                            <CBadge :color="getBadge(customer.location_status.living)">&nbsp;{{ customer.location_status.living ? 'Да' : 'Нет' }}&nbsp;</CBadge>
                                        </CCol>
                                        <template v-if="customer.location_status.living">
                                            <CCol sm="6" class="col-form-label">
                                                Номер апартаментов
                                            </CCol>
                                            <CCol sm="6" class="col-form-label">
                                                {{ customer.location_status.appartment }}
                                            </CCol>
                                        </template>
                                        <CCol sm="6" class="col-form-label">
                                            Работает в Москва-Сити
                                        </CCol>
                                        <CCol sm="6" class="col-form-label">
                                            <CBadge :color="getBadge(customer.location_status.working)">&nbsp;{{ customer.location_status.working ? 'Да' : 'Нет' }}&nbsp;</CBadge>
                                        </CCol>
                                        <template v-if="customer.location_status.working">
                                            <CCol sm="6" class="col-form-label">
                                                Название компании
                                            </CCol>
                                            <CCol sm="6" class="col-form-label">
                                                {{ customer.location_status.company }}
                                            </CCol>
                                        </template>
                                        <CCol sm="6" class="col-form-label">
                                            Часто бывает в Москва-Сити
                                        </CCol>
                                        <CCol sm="6" class="col-form-label">
                                            <CBadge :color="getBadge(customer.location_status.sometimes)">&nbsp;{{ customer.location_status.sometimes ? 'Да' : 'Нет' }}&nbsp;</CBadge>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div v-if="customer.orders" class="px-4 py-2 mb-4 border border-gray-300 rounded-md">
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Источники заказа</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.os }} {{ customer.osVersion }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Дата последнего действия в приложении</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ formatDate(customer.appLastEvent) }}</CCol>
                                    </CRow>
                                    <CRow form>
                                        <CCol sm="6" class="col-form-label"><b>Время, проведенное в приложении</b></CCol>
                                        <CCol sm="6" class="col-form-label">{{ customer.appTotalTime }}</CCol>
                                    </CRow>
                                </div>
                            </CCol>
                            <CCol v-if="adminOnly" sm="12">
                                <div class="px-4 py-2 mb-4 border border-gray-300 rounded-md">
                                    <CRow form>
                                        <CCol sm="3" class="col-form-label"><b>Комментарий о клиенте</b></CCol>
                                        <CCol sm="9" class="col-form-label">{{ customer.description }}</CCol>
                                    </CRow>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <div class="px-4 py-3 mb-4 border border-gray-300 rounded-md customer-chat">
                                    <div class="customer-chat__header">
                                        <b>{{ activeChatTitle }}</b>
                                        <CButton
                                            color="primary"
                                            size="sm"
                                            :disabled="creatingChat"
                                            @click="showCreateChatModal = true"
                                        >
                                            Новый чат
                                        </CButton>
                                    </div>
                                    <div v-if="!chat.items.length" class="customer-chat__empty mb-3">
                                        Чатов с клиентом пока нет
                                    </div>
                                    <div v-if="chat.items.length" class="chat-summary-cards chat-summary-cards--horizontal">
                                        <ChatSummaryCard
                                            v-for="thread in chat.items"
                                            :key="thread.chat_id"
                                            :chat="thread"
                                            :active="thread.chat_id === chat.activeChatId"
                                            :show-customer="false"
                                            @select="thread => selectChat(thread.chat_id)"
                                        />
                                    </div>
                                    <div ref="chatMessages" class="customer-chat__messages">
                                        <div
                                            v-for="message in chatMessages"
                                            :key="message.id"
                                            :class="[
                                                'customer-chat__message',
                                                message.sender_type === 'admin'
                                                    ? 'customer-chat__message--admin'
                                                    : message.sender_type === 'system'
                                                        ? 'customer-chat__message--system'
                                                        : 'customer-chat__message--customer'
                                            ]"
                                        >
                                            <div v-if="message.attachments && message.attachments.length" class="customer-chat__attachments">
                                                <div
                                                    v-for="attachment in message.attachments"
                                                    :key="attachment.id"
                                                    class="customer-chat__attachment"
                                                >
                                                    <img
                                                        v-if="isImageAttachment(attachment)"
                                                        :src="attachment.url"
                                                        :alt="attachment.original_name"
                                                        class="customer-chat__attachment-image"
                                                    />
                                                    <video
                                                        v-else-if="isVideoAttachment(attachment)"
                                                        :src="attachment.url"
                                                        controls
                                                        preload="metadata"
                                                        class="customer-chat__attachment-video"
                                                    ></video>
                                                </div>
                                            </div>
                                            <div class="customer-chat__message-text">
                                                <ChatMessageText :text="message.message" />
                                            </div>
                                            <div class="customer-chat__message-time">
                                                <span>{{ formatChatDate(message.created_at) }}</span>
                                                <span v-if="message.edited_at" class="customer-chat__message-edited">изменено</span>
                                                <ChatMessageEdit
                                                    :message="message"
                                                    :can-edit="canEditMessage(message)"
                                                    :saving="editingMessageId === message.id"
                                                    @save="saveEditedMessage"
                                                />
                                            </div>
                                        </div>
                                        <div v-if="!chatMessages.length" class="customer-chat__empty">
                                            Нет сообщений
                                        </div>
                                    </div>
                                    <div v-if="chat.pendingFiles.length" class="customer-chat__pending">
                                        <div
                                            v-for="(item, index) in chat.pendingFiles"
                                            :key="item.id"
                                            class="customer-chat__pending-item"
                                        >
                                            <div class="customer-chat__pending-name">{{ item.file.name }}</div>
                                            <button
                                                type="button"
                                                class="customer-chat__pending-remove"
                                                @click="removePendingFile(index)"
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    </div>
                                    <div class="customer-chat__composer">
                                        <CTextarea
                                            v-model.trim="chat.draft"
                                            rows="2"
                                            placeholder="Введите сообщение клиенту"
                                            :disabled="!chat.connected || chat.sending || !chat.activeChatId"
                                            @keydown.enter.exact.prevent="sendChatMessage"
                                        />
                                        <div class="customer-chat__composer-actions">
                                            <ChatQuickReplyPicker
                                                :disabled="isAttachDisabled"
                                                :customer="customer"
                                                :chat="activeChatContext"
                                                @select="onQuickReplySelect"
                                            />
                                            <label class="customer-chat__attach" :class="{ 'customer-chat__attach--disabled': isAttachDisabled }">
                                                <input
                                                    type="file"
                                                    hidden
                                                    multiple
                                                    accept="image/*,video/*"
                                                    :disabled="isAttachDisabled"
                                                    @change="onFilesSelected"
                                                >
                                                📎
                                            </label>
                                            <CButton
                                                color="primary"
                                                class="customer-chat__send"
                                                aria-label="Отправить сообщение"
                                                :disabled="!canSendMessage"
                                                @click="sendChatMessage"
                                            >
                                                <span class="customer-chat__send-icon">➤</span>
                                            </CButton>
                                        </div>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                    </div>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
        <CModal
            title="Новый чат"
            :show.sync="showCreateChatModal"
            :close-on-backdrop="false"
        >
            <CInput
                v-model.trim="newChatTitle"
                label="Тема обращения"
                placeholder="Например: Уточнение по доставке"
                :disabled="creatingChat"
                @keydown.enter.prevent="createCustomerChat"
            />
            <template #footer>
                <CButton color="secondary" :disabled="creatingChat" @click="showCreateChatModal = false">
                    Отмена
                </CButton>
                <CButton
                    color="primary"
                    :disabled="creatingChat || !newChatTitle"
                    @click="createCustomerChat"
                >
                    {{ creatingChat ? 'Создаём...' : 'Создать чат' }}
                </CButton>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import { io } from 'socket.io-client';
    import CustomerTabLinks from '@/components/CustomerTabLinks';
    import ChatSummaryCard from '@/components/chats/ChatSummaryCard';
    import ChatQuickReplyPicker from '@/components/chats/ChatQuickReplyPicker';
    import ChatMessageEdit from '@/components/chats/ChatMessageEdit';
    import ChatMessageText from '@/components/chats/ChatMessageText';
    import { getOrdersFrequencyText, getCustomerStatusText, getCustomerStatusBadge } from '@/utils/customer';


    export default {
        name: 'Customer',
        components:{
            CustomerTabLinks,
            ChatSummaryCard,
            ChatQuickReplyPicker,
            ChatMessageEdit,
            ChatMessageText,
        },

        data() {
            return {
                customer: {
                    location_status: {}
                },
                loading: {
                    customer: true,
                    orders: true
                },
                genders: {
                    0: 'Не выбрано',
                    1: 'Мужской',
                    2: 'Женский'
                },
                communicationMethods: {
                    'PUSH': 'Push-уведомления',
                    'EMAIL': 'Email',
                    'WHATSAPP': 'WhatsApp',
                    'TELEGRAM': 'Telegram'
                },
                chat: {
                    socket: null,
                    connected: false,
                    items: [],
                    activeChatId: null,
                    messagesByChat: {},
                    draft: '',
                    sending: false,
                    pendingFiles: []
                },
                showCreateChatModal: false,
                newChatTitle: '',
                creatingChat: false,
                editingMessageId: null,
                currentAdminId: null
            };
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            chatMessages() {
                return this.chat.messagesByChat[this.chat.activeChatId] || [];
            },
            activeChatTitle() {
                const activeChat = this.chat.items.find(item => +item.chat_id === +this.chat.activeChatId);
                return activeChat ? activeChat.title : 'Чаты с клиентом';
            },
            activeChatContext() {
                const activeChat = this.chat.items.find(item => +item.chat_id === +this.chat.activeChatId) || {};
                return {
                    title: activeChat.title || '',
                    order_id: activeChat.order_id || null
                };
            },
            canSendMessage() {
                return this.chat.connected
                    && !this.chat.sending
                    && !!this.chat.activeChatId
                    && (!!this.chat.draft || this.chat.pendingFiles.length > 0);
            },
            isAttachDisabled() {
                return !this.chat.connected || this.chat.sending || !this.chat.activeChatId;
            },
            createdAt() {
                return moment(this.customer.created_at).format('DD.MM.YYYY');
            },
            
        },

        mounted() {
            try {
                this.currentAdminId = Number(JSON.parse(localStorage.getItem('profile') || '{}').id) || null;
            } catch (e) {
                this.currentAdminId = null;
            }
            const id = this.$route.params.id;
            Vue.axios
                .get('/customers/get/' + id)
                .then(resp => {
                    this.customer = resp.data;
                    if(!this.customer.location_status) {
                        this.customer.location_status = {
                            living: false,
                            appartment: '',
                            working: false,
                            company: '',
                            sometimes: false
                        }
                    }
                    this.loading.customer = false;
                    this.loading.orders = false;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });

            this.initChat();
            this.loadChats();
        },

        beforeDestroy() {
            this.clearPendingFiles();
            if (this.chat.socket) {
                this.chat.socket.disconnect();
                this.chat.socket = null;
            }
        },

        methods: {
            getSocketBaseUrl() {
                const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || '';
                return apiBaseUrl
                    .replace(/\/api\/admin\/?$/, '')
                    .replace(/\/api\/?$/, '')
                    .replace(/\/admin\/?$/, '');
            },
            initChat() {
                const token = localStorage.getItem('user-token');
                if (!token) {
                    return;
                }

                this.chat.socket = io(this.getSocketBaseUrl(), {
                    path: '/socket.io',
                    reconnection: true,
                    transports: ['websocket'],
                    auth: {
                        role: 'admin',
                        token
                    },
                    query: {
                        role: 'admin',
                        token
                    }
                });

                this.chat.socket.on('connect', () => {
                    this.chat.connected = true;
                    this.chat.socket.emit('chat:subscribe', {
                        customer_id: Number(this.$route.params.id),
                        chat_id: Number(this.chat.activeChatId) || undefined
                    });
                    if (this.chat.activeChatId) {
                        this.fetchChatHistory(this.chat.activeChatId);
                    }
                });

                this.chat.socket.on('disconnect', () => {
                    this.chat.connected = false;
                });

                this.chat.socket.on('connect_error', err => {
                    this.chat.connected = false;
                    this.$root.$emit('showError', `Не удалось подключиться к сокету чата: ${err && err.message ? err.message : 'unknown error'}`);
                });

                this.chat.socket.on('chat:message:new', message => {
                    if (+message.customer_id !== +this.$route.params.id) {
                        return;
                    }
                    this.upsertChatMessage(message);
                    this.updateChatFromMessage(message);
                    if (+message.chat_id === +this.chat.activeChatId) {
                        this.markRead(message);
                        this.scrollChatToBottom();
                    }
                });

                this.chat.socket.on('chat:message:read', message => {
                    if (+message.customer_id !== +this.$route.params.id) {
                        return;
                    }
                    this.upsertChatMessage(message);
                    this.setChatUnreadCount(message.chat_id, 0);
                });

                this.chat.socket.on('chat:message:edited', message => {
                    if (+message.customer_id !== +this.$route.params.id) {
                        return;
                    }
                    this.upsertChatMessage(message);
                });

                this.chat.socket.on('chat:error', payload => {
                    const text = payload && payload.error ? payload.error : 'Ошибка чата';
                    this.$root.$emit('showError', text);
                });
            },
            async loadChats() {
                try {
                    const { data } = await Vue.axios.get(`/chats/customer/${this.$route.params.id}`);
                    this.applyChats(data.items || []);
                } catch {
                    this.$root.$emit('showError', 'Не удалось загрузить чаты клиента');
                }
            },
            async createCustomerChat() {
                const title = this.newChatTitle.trim();
                if (!title || this.creatingChat) {
                    return;
                }

                this.creatingChat = true;
                try {
                    const { data } = await Vue.axios.post(`/chats/customer/${this.$route.params.id}`, { title });
                    this.showCreateChatModal = false;
                    this.newChatTitle = '';
                    const createdChatId = data.chat?.chat_id;
                    await this.loadChats();
                    if (createdChatId) {
                        this.selectChat(createdChatId);
                    }
                } catch {
                    this.$root.$emit('showError', 'Не удалось создать чат');
                } finally {
                    this.creatingChat = false;
                }
            },
            applyChats(items = [], forcedChatId = null) {
                this.chat.items = items.slice().sort((a, b) => new Date(b.last_message_at || b.updated_at || b.created_at || 0) - new Date(a.last_message_at || a.updated_at || a.created_at || 0));
                const queryChatId = Number(this.$route.query.chat_id);
                const nextChatId = [forcedChatId, this.chat.activeChatId, queryChatId]
                    .map(value => Number(value))
                    .find(value => value && this.chat.items.some(item => +item.chat_id === +value)) || (this.chat.items[0] ? this.chat.items[0].chat_id : null);

                if (nextChatId) {
                    this.chat.activeChatId = nextChatId;
                }

                if (this.chat.connected && this.chat.activeChatId) {
                    this.fetchChatHistory(this.chat.activeChatId);
                }
            },
            selectChat(chatId) {
                this.chat.activeChatId = Number(chatId);
                this.setChatUnreadCount(chatId, 0);
                if (this.chat.connected) {
                    this.fetchChatHistory(chatId);
                }
            },
            fetchChatHistory(chatId = this.chat.activeChatId) {
                if (!this.chat.socket || !chatId) {
                    return;
                }
                this.chat.socket.emit('chat:history', {
                    chat_id: Number(chatId),
                    limit: 100,
                    offset: 0
                }, response => {
                    if (!response || !response.ok) {
                        return;
                    }
                    const history = response.messages || [];
                    this.$set(this.chat.messagesByChat, Number(chatId), []);
                    history.forEach(this.upsertChatMessage);
                    this.chatMessages.forEach(this.markRead);
                    this.setChatUnreadCount(chatId, 0);
                    this.scrollChatToBottom();
                });
            },
            onQuickReplySelect(text) {
                this.chat.draft = String(text || '');
            },
            canEditMessage(message) {
                return message
                    && message.sender_type === 'admin'
                    && this.currentAdminId
                    && Number(message.sender_id) === Number(this.currentAdminId);
            },
            saveEditedMessage({ messageId, message, done }) {
                if (!this.chat.socket || !messageId || this.editingMessageId) {
                    if (typeof done === 'function') {
                        done(false);
                    }
                    return;
                }
                this.editingMessageId = Number(messageId);
                this.chat.socket.emit('chat:message:edit', {
                    message_id: Number(messageId),
                    message
                }, response => {
                    this.editingMessageId = null;
                    if (!response || !response.ok) {
                        this.$root.$emit('showError', (response && response.error) || 'Не удалось изменить сообщение');
                        if (typeof done === 'function') {
                            done(false);
                        }
                        return;
                    }
                    this.upsertChatMessage(response.message);
                    if (typeof done === 'function') {
                        done(true);
                    }
                });
            },
            async sendChatMessage() {
                if (!this.canSendMessage || !this.chat.socket) {
                    return;
                }
                this.chat.sending = true;
                try {
                    const attachmentIds = await this.uploadPendingFiles();
                    this.chat.socket.emit('chat:message', {
                        chat_id: Number(this.chat.activeChatId),
                        message: this.chat.draft,
                        attachment_ids: attachmentIds
                    }, response => {
                        this.chat.sending = false;
                        if (!response || !response.ok) {
                            this.$root.$emit('showError', response && response.error ? response.error : 'Не удалось отправить сообщение');
                            return;
                        }
                        this.chat.draft = '';
                        this.clearPendingFiles();
                        this.scrollChatToBottom();
                    });
                } catch (e) {
                    this.chat.sending = false;
                    this.$root.$emit('showError', 'Не удалось загрузить вложения');
                }
            },
            async uploadPendingFiles() {
                const ids = [];
                for (const item of this.chat.pendingFiles) {
                    const formData = new FormData();
                    formData.append('chat_id', this.chat.activeChatId);
                    formData.append('file', item.file);
                    const { data } = await Vue.axios.post('/chats/attachments', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    if (data?.attachment?.id) {
                        ids.push(data.attachment.id);
                    }
                }
                return ids;
            },
            onFilesSelected(event) {
                const files = Array.from(event.target.files || []);
                files.forEach(file => {
                    if (!this.isAllowedMimeType(file.type)) {
                        this.$root.$emit('showError', 'Можно отправлять только фото и видео');
                        return;
                    }
                    if (file.size > 20 * 1000 * 1000) {
                        this.$root.$emit('showError', 'Размер файла не должен превышать 20 МБ');
                        return;
                    }
                    this.chat.pendingFiles.push({
                        id: `${Date.now()}-${file.name}-${this.chat.pendingFiles.length}`,
                        file
                    });
                });
                event.target.value = '';
            },
            removePendingFile(index) {
                this.chat.pendingFiles.splice(index, 1);
            },
            clearPendingFiles() {
                this.chat.pendingFiles = [];
            },
            markRead(message) {
                if (!message || !message.id || message.sender_type !== 'customer' || message.read_at || !this.chat.socket) {
                    return;
                }
                this.chat.socket.emit('chat:read', { message_id: message.id });
            },
            upsertChatMessage(message) {
                if (!message || !message.id || !message.chat_id) {
                    return;
                }
                const chatId = Number(message.chat_id);
                const messages = (this.chat.messagesByChat[chatId] || []).slice();
                const idx = messages.findIndex(item => +item.id === +message.id);
                if (idx >= 0) {
                    messages.splice(idx, 1, {
                        ...messages[idx],
                        ...message
                    });
                } else {
                    messages.push(message);
                }
                messages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                this.$set(this.chat.messagesByChat, chatId, messages);
            },
            updateChatFromMessage(message) {
                if (!message || message.sender_type === 'system') {
                    return;
                }

                const idx = this.chat.items.findIndex(item => +item.chat_id === +message.chat_id);
                if (idx < 0) {
                    this.loadChats();
                    return;
                }
                const attachmentsCount = Array.isArray(message.attachments) ? message.attachments.length : 0;
                const lastMessage = String(message.message || '').trim() || (attachmentsCount > 1 ? `${attachmentsCount} вложения` : attachmentsCount === 1 ? 'Вложение' : '');
                this.$set(this.chat.items, idx, {
                    ...this.chat.items[idx],
                    last_message: lastMessage,
                    last_message_at: message.created_at,
                    last_sender_type: message.sender_type,
                    unread_count: (+message.chat_id === +this.chat.activeChatId || message.sender_type !== 'customer')
                        ? 0
                        : (Number(this.chat.items[idx].unread_count) || 0) + 1
                });
                this.chat.items = this.chat.items.slice().sort((a, b) => new Date(b.last_message_at || b.updated_at || b.created_at || 0) - new Date(a.last_message_at || a.updated_at || a.created_at || 0));
            },
            setChatUnreadCount(chatId, count) {
                const idx = this.chat.items.findIndex(item => +item.chat_id === +chatId);
                if (idx < 0) {
                    return;
                }
                this.$set(this.chat.items, idx, {
                    ...this.chat.items[idx],
                    unread_count: count
                });
            },
            formatChatDate(value) {
                if (!value) {
                    return '';
                }
                return moment(value).format('DD.MM.YYYY HH:mm');
            },
            isImageAttachment(attachment) {
                return String(attachment?.mime_type || '').startsWith('image/');
            },
            isVideoAttachment(attachment) {
                return String(attachment?.mime_type || '').startsWith('video/');
            },
            isAllowedMimeType(mimeType) {
                const value = String(mimeType || '');
                return value.startsWith('image/') || value.startsWith('video/');
            },
            scrollChatToBottom() {
                this.$nextTick(() => {
                    if (this.$refs.chatMessages) {
                        this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight;
                    }
                });
            },
            goBack() {
                this.$router.push({ path: '/customers' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            getCustomerStatusBadge,
            formatDate(date) {
                return moment(date).format('DD.MM.YYYY');
            },
            getCustomerStatusText,
            getOrdersFrequencyText,
        },
    };
</script>

<style>
.badge.removed-user {
    font-size: 100%;
}

.customer-chat__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.customer-chat__messages {
    max-height: 380px;
    overflow-y: auto;
    border: 1px solid #e4e7ea;
    border-radius: 8px;
    padding: 10px;
    background: #ffffff;
}

.customer-chat__message {
    max-width: 80%;
    padding: 8px 10px;
    margin-bottom: 8px;
    border-radius: 8px;
}

.customer-chat__message--admin {
    margin-left: auto;
    background: #321fdb;
    color: #ffffff;
}

.customer-chat__message--customer {
    background: #f1f3f5;
    color: #23282c;
}

.customer-chat__message--system {
    margin-left: auto;
    margin-right: auto;
    background: #fff8e7;
    color: #6b4e16;
}

.customer-chat__message-text {
    white-space: pre-wrap;
    word-break: break-word;
}

.customer-chat__attachments {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
}

.customer-chat__attachment-image,
.customer-chat__attachment-video {
    display: block;
    width: 100%;
    max-width: 280px;
    border-radius: 8px;
}

.customer-chat__message-time {
    font-size: 11px;
    opacity: 0.8;
    margin-top: 4px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
}

.customer-chat__message-edited {
    font-style: italic;
}

.customer-chat__empty {
    color: #8a93a2;
}

.customer-chat__composer {
    margin-top: 12px;
}

.customer-chat__composer-actions {
    display: flex;
    align-items: center;
}

.customer-chat__attach {
    width: 36px;
    height: 36px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 0;
    margin-right: 8px;
}

.customer-chat__attach--disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.customer-chat__send {
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 6px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.customer-chat__send-icon {
    font-size: 14px;
    line-height: 1;
}

.customer-chat__pending {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 10px 0 -10px 0;
}

.customer-chat__pending-item {
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    padding: 6px 10px;
    border-radius: 8px;
    background: #f3f4f6;
}

.customer-chat__pending-name {
    font-size: 12px;
}

.customer-chat__pending-remove {
    width: 20px;
    border: 0;
    background: transparent;
    font-size: 18px;
    line-height: 1;
}
</style>

